<template>
  <q-layout>
    <q-page-container>
      <q-page style="width: 100%; height: 100%; padding: 0 5em 0">
        <SignOutButton class="signout-button" />

        <div style="display: inline-block; width: 100%; margin-top: 40px;">
          <HomeLogo />

          <div style="
            display: inline-block;
            position: relative;
            float: right;
            margin-top: 8px;
            "
          >
            <q-btn
              class="usersButton"
              no-caps
              unelevated
              text-color="white"
              label="Users"
              @click="setAdminMode('User List')"
            />
            <q-btn
              class="userGroupsButton"
              no-caps
              unelevated
              text-color="white"
              label="User Groups"
              @click="setAdminMode('User Group List')"
            />
            <q-btn
              class="homeLogsButton"
              no-caps
              unelevated
              text-color="black"
              label="Home"
              @click="handleHome"
            />
            <q-btn
              class="homeLogsButton"
              no-caps
              unelevated
              text-color="black"
              label="Logs"
              @click="handleLogs"
              v-if="displayLogsButton"
            />
            <HelpButtonAndDarkMode
              @toggleDarkMode="toggleDarkMode"
              helpScreen="adminPage"
            />
          </div>
        </div>

        <div>
          <div class="table_header">
            <span style="marginLeft: 20px">
              {{ adminMode }}
            </span>
          </div>

          <div style="width: 100%">
            <div v-show="adminMode === 'User List'">
              <UsersTable
                @setAdminMode="setAdminMode"
                :currentUserUID="currentUserUID"
                :darkMode="darkMode"
                :userGroupsTable="userGroupsTable"
                :adminForm="adminForm"
                :adminDelete="adminDelete"
                ref="usersTable"
              />
            </div>

            <div v-show="adminMode === 'User Group List'">
              <UserGroupsTable
                @setAdminMode="setAdminMode"
                :currentUserUID="currentUserUID"
                :darkMode="darkMode"
                :adminForm="adminForm"
                :adminDelete="adminDelete"
                ref="userGroupsTable"
              />
            </div>

            <div
              v-show="adminMode === 'Add User' || adminMode === 'Update User' || adminMode === 'Add User Group' || adminMode === 'Update User Group'"
              class="form-container"
            >
              <AdminForm
                @setAdminMode="setAdminMode"
                :currentUserUID="currentUserUID"
                :ipAddress="ipAddress"
                :adminMode="adminMode"
                :usersTable="usersTable"
                :userGroupsTable="userGroupsTable"
                ref="adminForm"
              />
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>

    <AppFooter />
  </q-layout>

  <AdminDelete
    :currentUserUID="currentUserUID"
    :ipAddress="ipAddress"
    :usersTable="usersTable"
    :userGroupsTable="userGroupsTable"
    ref="adminDelete"
  />
</template>

<script>
import SignOutButton from "./SignOutButton.vue";
import HomeLogo, { handleHome } from "../layout/HomeLogo.vue";
import HelpButtonAndDarkMode from "../helpTour/HelpButtonDarkMode.vue";
import UsersTable from "./UsersTable.vue";
import UserGroupsTable from "./UserGroupsTable.vue";
import AdminForm from "./AdminForm.vue";
import AdminDelete from "./AdminDelete.vue";
import AppFooter from "../layout/AppFooter.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import AuthHelper from "../helper/AuthHelper.js";
import CommonHelper from "../helper/CommonHelper.js";
import router from "../../router";

export default {
  name: "AdminPage",
  components: {
    SignOutButton,
    HomeLogo,
    HelpButtonAndDarkMode,
    UsersTable,
    UserGroupsTable,
    AdminForm,
    AdminDelete,
    AppFooter
  },
  setup() {
    const currentUserUID = ref();
    const ipAddress = ref();

    const displayLogsButton = computed(() => {
      return currentUserUID.value === process.env.VUE_APP_DEFAULT_USER_UID;
    });

    function handleLogs() {
      router.push("/logs");
    }

    onBeforeMount(async () => {
      const userData = await AuthHelper.getCurrentUserData(false, true);
      const currentUserAccessLevel = userData.accessLevel;

      if (!currentUserAccessLevel.includes("Admin")) {
        router.push("/unauth");
      } else {
        currentUserUID.value = userData.uid;
        ipAddress.value = await AuthHelper.getIpAddress();
      }
    });

    const adminMode = ref("User List");
    const darkMode = ref();

    function setAdminMode(newAdminMode) {
      adminMode.value = newAdminMode;
    }

    function toggleDarkMode(value) {
      darkMode.value = value;
    }

    // Sets the color of 'Users', 'User Groups', and 'Home' buttons
    watch([adminMode, darkMode], () => {
      const userListActive = adminMode.value === "User List" || adminMode.value === "Add User" || adminMode.value === "Update User";
      document.documentElement.style.setProperty("--users-btn", CommonHelper.getHeaderButtonColor(userListActive, darkMode.value));

      const userGroupListActive = adminMode.value === "User Group List" || adminMode.value === "Add User Group" || adminMode.value === "Update User Group";
      document.documentElement.style.setProperty("--user-groups-btn", CommonHelper.getHeaderButtonColor(userGroupListActive, darkMode.value));

      document.documentElement.style.setProperty("--home-logs-btn", darkMode.value ? "#FFFFFF" : "#000000");
    })

    const usersTable = ref();
    const userGroupsTable = ref();
    const adminForm = ref();
    const adminDelete = ref();

    return {
      //variable properties
      currentUserUID,
      ipAddress,
      displayLogsButton,
      adminMode,
      darkMode,
      usersTable,
      userGroupsTable,
      adminForm,
      adminDelete,

      //functions
      handleLogs,
      setAdminMode,
      toggleDarkMode,
      handleHome
    };
  },
};
</script>

<style type="text/scss" lang="scss">
:root {
  --users-btn: #0067c1;
  --user-groups-btn: #707070;
  --home-logs-btn: #000000;
}
</style>

<style scoped>
.form-container {
  padding: 5% 10% 5% 10%;
  height: 48.5em;
  overflow-y: auto;
}

.usersButton {
  color: var(--users-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.userGroupsButton {
  color: var(--user-groups-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.homeLogsButton {
  color: var(--home-logs-btn) !important;
  font-size: 20px;
}
</style>